<template>
	<div class="row">
		<div class="col-xl-4 col-md-6 mb-4">
			<bga2-info-card 
				:classe="{
					'border-left-success': dados.caixa > 0,
					'border-left-danger': dados.caixa < 0,
					'border-left-secondary': dados.caixa == 0
				}">
		    	<div class="col mr-2">
					<div 
						class="text-xs font-weight-bold text-uppercase mb-1"
						:class="{
							'text-success': dados.caixa > 0,
							'text-danger': dados.caixa < 0,
							'text-secondary': dados.caixa == 0
						}">
						Caixa
					</div>
					<div class="h5 mb-0 font-weight-bold text-gray-800">	
						R$ {{ dados.caixa_br }}
					</div>
				</div>
				<div class="col-auto">
					<i class="fas fa-dollar-sign fa-2x text-gray-300"></i>
				</div>
		    </bga2-info-card>
		</div>
		<div class="col-xl-4 col-md-6 mb-4">
			<bga2-info-card 
				classe="border-left-success">
		    	<div class="col mr-2">
					<div 
						class="text-xs text-success font-weight-bold text-uppercase mb-1" >
						Receita
					</div>
					<div class="h5 mb-0 font-weight-bold text-gray-800">	
						R$ {{ dados.receita_br }}
					</div>
				</div>
				<div class="col-auto">
					<i class="fas fa-dollar-sign fa-2x text-gray-300"></i>
				</div>
		    </bga2-info-card>
		</div>
		<div class="col-xl-4 col-md-6 mb-4">
			<bga2-info-card 
				classe="border-left-danger">
		    	<div class="col mr-2">
					<div 
						class="text-xs text-danger font-weight-bold text-uppercase mb-1">
						Despesas
					</div>
					<div class="h5 mb-0 font-weight-bold text-gray-800">	
						R$ {{ dados.despesas_br }}
					</div>
				</div>
				<div class="col-auto">
					<i class="fas fa-dollar-sign fa-2x text-gray-300"></i>
				</div>
		    </bga2-info-card>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['date'],
		data(){
			return {
				dados: []
			}
		},
		created(){
			this.getDados();
		},
		methods: {
			getDados(){
				axios.get(this.$url+'/api/adm/financeiro/caixa?data='+this.date)
	            .then(response => {
	            	this.dados = response.data;
	            })
	            .catch(error => {
	            	console.log(error)
	            });
			},
		},
		watch: {
			date(){
				if(this.date){
					this.getDados()
				}
			}
		}
	}
</script>